
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function About() {
  const { ref: sectionRef, isVisible } = useScrollAnimation({ threshold: 0.15 });
  const { ref: cardsRef, isVisible: cardsVisible } = useScrollAnimation({ rootMargin: '0px 0px -50px 0px' });

  return (
    <section id="about" className="py-24 bg-gradient-to-b from-rose-50/30 via-amber-50/20 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div ref={sectionRef} className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className={`relative scroll-animate-left ${isVisible ? 'visible' : ''}`}>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/f1f21a1dcceea1db871550311b46001d.jpg"
                alt="House of FMR Event Team"
                className="w-full h-[500px] object-cover object-top"
              />
            </div>

            {/* Experience Badge */}
            <div className="absolute bottom-6 left-6 bg-white rounded-xl p-5 shadow-2xl border border-amber-100">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-100 to-amber-200 flex items-center justify-center shadow-inner">
                  <i className="ri-award-fill text-2xl text-amber-700"></i>
                </div>
                <div>
                  <p className="text-2xl font-display text-stone-900 font-light">12+</p>
                  <p className="text-sm text-stone-500">Years Experience</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className={`space-y-6 scroll-animate-right ${isVisible ? 'visible' : ''}`}>
            <div className="flex items-center gap-3">
              <div className="w-10 h-px bg-gradient-to-r from-amber-400 to-amber-600"></div>
              <span className="text-amber-600 text-xs font-semibold tracking-[0.25em] uppercase">Our Story</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-display text-stone-900 leading-tight font-light">
              House of FMR
            </h2>

            <p className="text-stone-600 leading-relaxed">
              With over 12 years of excellence in event styling and equipment hire, House of FMR specialises in creating beautiful intimate gatherings for 30-80 guests. From milestone birthdays to special celebrations, we handle every detail with care.
            </p>

            <p className="text-stone-600 leading-relaxed">
              Our personalised approach means you get dedicated attention and professional styling that transforms your venue. We also offer equipment hire packages and can coordinate larger events through our trusted subcontractor network.
            </p>

            {/* Features */}
            <div
              ref={cardsRef}
              className={`grid grid-cols-2 gap-4 pt-4 stagger-children ${cardsVisible ? 'visible' : ''}`}
            >
              {[
                { icon: 'ri-palette-line', title: 'Decoration Styling' },
                { icon: 'ri-goblet-line', title: 'Glassware Hire' },
                { icon: 'ri-lightbulb-line', title: 'Lighting Setup' },
                { icon: 'ri-cake-2-line', title: 'Event Coordination' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-3 bg-white rounded-lg shadow-md border border-amber-100/50 hover:shadow-lg hover:border-amber-200 transition-all">
                  <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-100 to-amber-200 flex items-center justify-center shadow-inner">
                    <i className={`${item.icon} text-lg text-amber-700`}></i>
                  </div>
                  <span className="text-sm font-medium text-stone-700">{item.title}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
